import IndexPagination from "@/components/pagination/IndexPagination";

interface ReviewThreadsNavHeaderProps {
  totalCount: number;
  page: number;
  pageSize: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  onPreviousClick: () => void;
  onNextClick: () => void;
}

export const ReviewThreadsNavHeader = ({
  totalCount,
  page,
  pageSize,
  hasPreviousPage,
  hasNextPage,
  onPreviousClick,
  onNextClick,
}: ReviewThreadsNavHeaderProps) => (
  <header className="navbar navbar--sub">
    <div>
      <h2 className="me-2">
        {totalCount} henvendelse{totalCount === 1 ? "" : "r"}
      </h2>
    </div>
    <div className="justify-content-end">
      <IndexPagination
        page={page}
        pageSize={pageSize}
        totalCount={totalCount}
        hasPreviousPage={hasPreviousPage}
        hasNextPage={hasNextPage}
        onPreviousClick={onPreviousClick}
        onNextClick={onNextClick}
      />
    </div>
  </header>
);
